const WORKING_CONFIG = {
    timezone: 'Europe/Kyiv',
    startHour: 9,
    endHour: 18,
    workingDays: [1, 2, 3, 4, 5], // From Monday to Friday
};

export { WORKING_CONFIG };
